import React from 'react';
import { Download, RefreshCw } from 'lucide-react';

export const StockSummaryCards = ({ summary, fmtMoney, onExport, onRefresh }) => (
  <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
    <div className="flex items-center gap-2 flex-wrap">
      <div className="bg-white border border-slate-200 rounded-lg px-4 py-2 text-center shadow-sm">
        <p className="text-xl font-black text-slate-800 leading-none" data-testid="stocktab-total-units">{summary.units}</p>
        <p className="text-[9px] text-slate-500 uppercase font-semibold mt-0.5">Unidades totales</p>
      </div>
      <div className="bg-white border border-amber-200 rounded-lg px-4 py-2 text-center shadow-sm">
        <p className="text-xl font-black text-amber-600 leading-none" data-testid="stocktab-low-sizes">{summary.low}</p>
        <p className="text-[9px] text-slate-500 uppercase font-semibold mt-0.5">Tallas bajas</p>
      </div>
      <div className="bg-white border border-red-200 rounded-lg px-4 py-2 text-center shadow-sm">
        <p className="text-xl font-black text-red-600 leading-none" data-testid="stocktab-oos-sizes">{summary.oos}</p>
        <p className="text-[9px] text-slate-500 uppercase font-semibold mt-0.5">Tallas agotadas</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg px-4 py-2 text-center shadow-sm">
        <p className="text-xl font-black text-slate-700 leading-none" data-testid="stocktab-inventory-value">{fmtMoney(summary.costValue)}</p>
        <p className="text-[9px] text-slate-500 uppercase font-semibold mt-0.5">Dinero en inventario</p>
      </div>
      <div className="bg-white border border-emerald-200 rounded-lg px-4 py-2 text-center shadow-sm">
        <p className="text-xl font-black text-emerald-600 leading-none" data-testid="stocktab-retail-value">{fmtMoney(summary.retailValue)}</p>
        <p className="text-[9px] text-slate-500 uppercase font-semibold mt-0.5">Dinero por vender</p>
      </div>
      <div className="bg-white border border-cyan-200 rounded-lg px-4 py-2 text-center shadow-sm">
        <p className="text-xl font-black text-cyan-600 leading-none" data-testid="stocktab-margin-value">{fmtMoney(summary.retailValue - summary.costValue)}</p>
        <p className="text-[9px] text-slate-500 uppercase font-semibold mt-0.5">Ganancia potencial</p>
      </div>
    </div>
    <div className="flex items-center gap-2">
      <button onClick={onExport}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 text-slate-700 text-xs font-semibold rounded-lg hover:bg-slate-50 transition-colors shadow-sm"
        data-testid="stocktab-export-csv">
        <Download className="w-3.5 h-3.5" /> CSV
      </button>
      <button onClick={onRefresh}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 text-slate-700 text-xs font-semibold rounded-lg hover:bg-slate-50 transition-colors shadow-sm"
        data-testid="stocktab-refresh">
        <RefreshCw className="w-3.5 h-3.5" /> Actualizar
      </button>
    </div>
  </div>
);

export const CostInputRows = ({ visibleProducts, saving, onCommitCost }) => (
  <>
    {[['cost_kids_mxn', 'Costo niño'], ['cost_adult_mxn', 'Costo adulto']].map(([field, label]) => (
      <tr key={field} className="border-b border-cyan-100 bg-cyan-50/40" data-testid={`cost-row-${field}`}>
        <td className="sticky left-0 z-10 px-3 py-1.5 text-[10px] font-bold text-cyan-800 uppercase whitespace-nowrap bg-cyan-50">{label} $</td>
        {visibleProducts.map(p => (
          <td key={p.product_id} className="px-2 py-1.5 text-center">
            <input
              key={`${p.product_id}-${field}-${p[field] || 0}`}
              type="number" min="0" step="0.01" defaultValue={p[field] || ''}
              placeholder="0" disabled={saving === p.product_id}
              onBlur={(e) => {
                const v = Math.max(0, parseFloat(e.target.value) || 0);
                if (v !== (p[field] || 0)) onCommitCost(p, field, v);
              }}
              onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
              className="w-14 text-center text-[11px] font-semibold rounded border border-cyan-200 bg-white text-cyan-900 py-1 focus:outline-none focus:ring-2 focus:ring-cyan-500 disabled:opacity-50 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
              data-testid={`cost-input-${field}-${p.product_id}`}
            />
          </td>
        ))}
        <td /><td /><td />
      </tr>
    ))}
  </>
);
